import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { NoDataViewVariant } from './NoDataView';

export const StyledNoDataContainer = styled.div<{ variant: NoDataViewVariant }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: ${({ variant }) => (variant === NoDataViewVariant.monthlyVisits ? '16px 0px 32px' : '32px 0')};
`;

export const StyledNoDataTitle = styled.p`
  margin: 16px 0 0;
  ${setFontVariant('report', colorsPalettes.carbon[500])};
  line-height: 20px;
`;

export const StyledNoDataSubtitle = styled.p`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[300])};
  line-height: 20px;
  margin: 0;
`;
